module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page--type2",
    attrs: {
      "id": "page-bekenden"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', {
    staticClass: "page-bekenden__description"
  }, [_vm._v("Deze hybride docenten ken je misschien al")]), _vm._v(" "), _c('div', {
    staticClass: "page-bekenden__persona page-bekenden__rutte"
  }, [_c('flipper', {
    staticClass: "page-bekenden__flipper"
  }, [_c('div', {
    slot: "front"
  }, [_c('div', {
    staticClass: "portret portret--white"
  })]), _vm._v(" "), _c('div', {
    slot: "back"
  }, [_c('div', {
    staticClass: "portret portret--white portret--back"
  }), _vm._v(" "), _c('p', [_vm._v("Mark Rutte")])])]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('page-next-button', {
    staticClass: "page-bekenden__next-section",
    on: {
      "click": _vm.nextSectionHandler
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-bekenden__persona page-bekenden__white"
  }, [_c('flipper', {
    staticClass: "page-bekenden__flipper"
  }, [_c('div', {
    slot: "front"
  }, [_c('div', {
    staticClass: "portret portret--white"
  })]), _vm._v(" "), _c('div', {
    slot: "back"
  }, [_c('div', {
    staticClass: "portret portret--white portret--back"
  }), _vm._v(" "), _c('p', [_vm._v("Walter White")])])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-bekenden__next-btn"
    }
  }, [_c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container page-bekenden__jobs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 page-bekenden__job page-bekenden__job--left"
  }, [_vm._v("\n                        Docent maatschappijleer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('img', {
    staticClass: "page-bekenden__plus",
    attrs: {
      "src": require("../../assets/icons/plus-white.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-5 page-bekenden__job page-bekenden__job--right"
  }, [_vm._v("\n                        Minister-president\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container page-bekenden__jobs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 page-bekenden__job page-bekenden__job--left"
  }, [_vm._v("\n                        Docent scheikunde\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('img', {
    staticClass: "page-bekenden__plus",
    attrs: {
      "src": require("../../assets/icons/plus-white.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-5 page-bekenden__job page-bekenden__job--right"
  }, [_vm._v("\n                        Heisenberg\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e58eb62","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-bekenden.vue
// module id = 139
// module chunks = 0